// src/lib/BaseAlignPlugin.ts
import { BaseParagraphPlugin, createSlatePlugin } from "@udecode/plate";
var BaseAlignPlugin = createSlatePlugin({
  key: "align",
  inject: {
    isBlock: true,
    nodeProps: {
      defaultNodeValue: "start",
      nodeKey: "align",
      styleKey: "textAlign",
      validNodeValues: ["start", "left", "center", "right", "end", "justify"]
    },
    targetPlugins: [BaseParagraphPlugin.key],
    targetPluginToInject: ({ editor, plugin }) => ({
      parsers: {
        html: {
          deserializer: {
            parse: ({ element, node }) => {
              if (element.style.textAlign) {
                node[editor.getType(plugin)] = element.style.textAlign;
              }
            }
          }
        }
      }
    })
  }
});

// src/lib/transforms/setAlign.ts
import {
  getInjectMatch
} from "@udecode/plate";
var setAlign = (editor, {
  setNodesOptions,
  value
}) => {
  const { defaultNodeValue, nodeKey } = editor.getInjectProps(BaseAlignPlugin);
  const match = getInjectMatch(editor, editor.getPlugin(BaseAlignPlugin));
  if (value === defaultNodeValue) {
    editor.tf.unsetNodes(nodeKey, {
      match,
      ...setNodesOptions
    });
  } else {
    editor.tf.setNodes(
      { [nodeKey]: value },
      {
        match,
        ...setNodesOptions
      }
    );
  }
};
export {
  BaseAlignPlugin,
  setAlign
};
//# sourceMappingURL=index.mjs.map